import React, { useMemo } from "react";

export default function JungleBackground() {
  const fireflies = useMemo(
    () => [
      { left: "8%", top: "18%", delay: "0s" },
      { left: "84%", top: "22%", delay: "0.4s" },
      { left: "18%", top: "40%", delay: "0.8s" },
      { left: "76%", top: "44%", delay: "1.2s" },

      { left: "10%", top: "66%", delay: "0.3s" },
      { left: "88%", top: "62%", delay: "0.7s" },
      { left: "26%", top: "28%", delay: "1.0s" },
      { left: "70%", top: "30%", delay: "0.5s" },
    ],
    [],
  );

  return (
    <div className="jt-bg" aria-hidden="true">
      <div className="jt-bg-grad" />
      <div className="jt-bg-fog" />
      {fireflies.map((f, i) => (
        <span
          key={i}
          className="jt-firefly"
          style={{ left: f.left, top: f.top, animationDelay: f.delay }}
        />
      ))}
    </div>
  );
}
